
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class MyLayout extends Vue {
  @Prop({ default: () => [] }) menuList: Array<{
    label: string
    value: string
  }>
  @Prop() menuKey: string

  created(): void {
    if (this.menuList.length === 0) return

    this.menuKey = this.menuKey ?? this.menuList[0].value
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
